/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sig_type_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download the PNG, then insert it as an image in your PDF editor (Adobe Acrobat, Preview on Mac, or a free tool like DocHub). Because the background is transparent, it drops onto the signature line without covering the text or lines behind it.`)
};

const es_sig_type_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarga el PNG, luego insértalo como una imagen en tu editor de PDF (Adobe Acrobat, Preview en Mac, o una herramienta gratuita como DocHub). Porque el fondo es transparente, se coloca en la línea de firma sin cubrir el texto o las líneas detrás de ella.`)
};

const de_sig_type_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laden Sie die PNG herunter, und fügen Sie sie dann als Bild in Ihrem PDF-Editor ein (Adobe Acrobat, Preview auf Mac oder ein kostenloses Tool wie DocHub). Da der Hintergrund transparent ist, wird er auf die Signaturzeile eingefügt, ohne den Text oder die Zeilen dahinter zu überlagern.`)
};

const nl_sig_type_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download de PNG en voeg deze vervolgens in als afbeelding in uw PDF-editor (Adobe Acrobat, Preview op Mac of een gratis gereedschap als DocHub). Omdat de achtergrond transparant is, valt het op de handtekeningregel zonder de tekst of lijnen erachter te bedekken.`)
};

const fr_sig_type_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléchargez le PNG, puis insérez-le en tant qu'image dans votre éditeur PDF (Adobe Acrobat, Aperçu sur Mac, ou un outil gratuit comme DocHub). Comme l'arrière-plan est transparent, il s'insère sur la ligne de signature sans couvrir le texte ou les lignes derrière.`)
};

const it_sig_type_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scarica il PNG, poi inseriscilo come immagine nel tuo editor PDF (Adobe Acrobat, Preview su Mac, o uno strumento gratuito come DocHub). Poiché lo sfondo è trasparente, si inserisce sulla riga di firma senza coprire il testo o le linee dietro.`)
};

const pt_br2_sig_type_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baixe o PNG, depois insira como imagem no seu editor de PDF (Adobe Acrobat, Preview no Mac, ou uma ferramenta gratuita como DocHub). Porque o fundo é transparente, ele cai na linha de assinatura sem cobrir o texto ou linhas atrás.`)
};

const pt_sig_type_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarregue o PNG, depois insira-o como imagem no seu editor PDF (Adobe Acrobat, Preview no Mac, ou uma ferramenta gratuita como DocHub). Porque o fundo é transparente, cai na linha de assinatura sem cobrir o texto ou linhas atrás.`)
};

const ja_sig_type_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNGをダウンロードしてから、PDFエディター（Adobe Acrobat、Mac上のプレビュー、またはDocHubなどの無料ツール）に画像として挿入します。背景が透明であるため、テキストまたはその背後の線をカバーすることなく、署名欄にドロップされます。`)
};

const zh_sig_type_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载 PNG，然后在您的 PDF 编辑器中插入它作为图像（Adobe Acrobat、Mac 上的预览或 DocHub 等免费工具）。因为背景是透明的，它会放在签名行上，不会覆盖其后面的文本或线条。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sig_type_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sig_type_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sig_type_faq3_a", locale)
	if (locale === "en") return en_sig_type_faq3_a(inputs)
	if (locale === "es") return es_sig_type_faq3_a(inputs)
	if (locale === "de") return de_sig_type_faq3_a(inputs)
	if (locale === "nl") return nl_sig_type_faq3_a(inputs)
	if (locale === "fr") return fr_sig_type_faq3_a(inputs)
	if (locale === "it") return it_sig_type_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_sig_type_faq3_a(inputs)
	if (locale === "pt") return pt_sig_type_faq3_a(inputs)
	if (locale === "ja") return ja_sig_type_faq3_a(inputs)
	return zh_sig_type_faq3_a(inputs)
};